import { Plus, Settings2, Trash2, X, Star } from "@/lib/icons";
import { FOCUS_META } from "@/components/HabitFocus";

const todayLabel = () => new Date().toLocaleDateString(undefined, { weekday: "long", month: "short", day: "numeric" });

export function TodayBar({ pendingCount, showForm, manage, onAdd, onManage, children }) {
  return (
    <div className="flex items-center justify-between gap-3 flex-wrap" data-testid="today-bar">
      <div>
        <div className="text-[10px] font-bold uppercase tracking-widest text-amber-800">Today · {todayLabel()}</div>
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold text-stone-900 mt-0.5">
          {pendingCount > 0 ? `${pendingCount} gentle nudge${pendingCount === 1 ? "" : "s"} waiting` : "Check in, then mark what you did"}
        </h1>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {children}
        <button data-testid="manage-habits-btn" onClick={onManage}
          className={`inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-semibold border transition-colors ${manage ? "bg-stone-900 text-white border-stone-900" : "bg-white border-stone-300 text-stone-700 hover:border-stone-500"}`}>
          <Settings2 className="w-4 h-4" /> {manage ? "Done managing" : "Manage habits"}
        </button>
        <button data-testid="new-habit-btn" onClick={onAdd} className="amber-btn text-sm inline-flex items-center gap-1.5">
          {showForm ? <X className="w-4 h-4" /> : <Plus className="w-4 h-4" />} {showForm ? "Close" : "Add habit"}
        </button>
      </div>
    </div>
  );
}

export function ManageHabitsPanel({ habits, onRemove, onFocus }) {
  return (
    <div className="warm-card p-5" data-testid="manage-habits-panel">
      <div className="text-[10px] font-bold uppercase tracking-widest text-stone-500 mb-3">Manage habits · archive keeps your history, nothing is lost</div>
      {habits.length === 0 && <p className="text-sm text-stone-500">No habits yet — use “Add habit” above.</p>}
      <ul className="divide-y divide-stone-100">
        {habits.map((h) => (
          <li key={h.id} className="flex items-center justify-between gap-3 py-2.5" data-testid={`manage-row-${h.id}`}>
            <div className="min-w-0">
              <div className="font-semibold text-stone-900 truncate flex items-center gap-1.5">
                {h.focus === "keystone" && <Star className="w-3.5 h-3.5 text-amber-600 fill-amber-400" />} {h.title}
              </div>
              <div className="text-xs text-stone-500">{h.kind === "start" ? "Starting" : "Easing off"} · {FOCUS_META[h.focus]?.label || "Active"} · {h.total_completions} check-in{h.total_completions === 1 ? "" : "s"}</div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              {h.focus !== "keystone" && (
                <button data-testid={`manage-keystone-${h.id}`} onClick={() => onFocus(h, "keystone")} className="text-xs font-semibold text-amber-800 hover:text-amber-900 px-2 py-1 rounded-full bg-amber-50">Make Keystone</button>
              )}
              <button data-testid={`manage-remove-${h.id}`} onClick={() => onRemove(h.id)} className="inline-flex items-center gap-1 text-xs font-semibold text-stone-600 hover:text-stone-900 px-3 py-1.5 rounded-full border border-stone-300 hover:border-stone-500">
                <Trash2 className="w-3.5 h-3.5" /> Archive
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
